import type { FC } from "react";
import { Button, Card, Spacing, Text } from "@huub-web/ui";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";
import { useTranslation } from "react-i18next";

/**
 * VEH banner: sufficient/marginal → continue to assessment,
 * insufficient → fall back to advisor.
 */
export const VerenigingEigenHuisMaximumMortgageResultBanner: FC<
  ThemeSlotPropsMap["maximumMortgageResultBanner"]
> = ({ resultType, hasPartner, advisorAction, continueAction }) => {
  const { t } = useTranslation();

  const action = resultType === "insufficient" ? advisorAction : continueAction;

  return (
    <Card variant="gradient" overflowHidden>
      <Text as="h3" variant="displayM" bold>
        {t(
          `vehResultBanner.${resultType}.title.${hasPartner ? "plural" : "singular"}`,
        )}
      </Text>
      <Text as="p">
        {t(
          `vehResultBanner.${resultType}.description.${hasPartner ? "plural" : "singular"}`,
        )}
      </Text>
      <Spacing />
      <Button
        variant="background"
        alignSelf="flex-start"
        as={action?.href ? "a" : "button"}
        href={action?.href}
        tracking={action?.tracking}
        onClick={action?.onClick}
      >
        {action?.value ??
          t(
            `vehResultBanner.${resultType}.cta.${hasPartner ? "plural" : "singular"}`,
          )}
      </Button>
    </Card>
  );
};
